import React from 'react';
import { Clock, MapPin, Phone, Mail, Trophy, Sparkles, Thermometer, Car, Shield } from 'lucide-react';

const Flyer = () => {
  const images = {
    exterior: 'https://customer-assets.emergentagent.com/job_fun-arcade-33/artifacts/vt2kqe7i_IMG_7713.jpeg',
    interior1: 'https://customer-assets.emergentagent.com/job_fun-arcade-33/artifacts/h4y30skp_IMG_6755.jpeg',
    interior2: 'https://customer-assets.emergentagent.com/job_fun-arcade-33/artifacts/h46k7bpp_IMG_6746.jpeg'
  };

  return (
    <div className="flyer-container">
      <style>{`
        @media print {
          body { margin: 0; padding: 0; }
          .flyer-container { width: 210mm; height: 297mm; margin: 0; }
          @page { size: A4; margin: 0; }
          button { display: none; }
        }
        
        .flyer-container {
          width: 210mm;
          height: 297mm;
          margin: 0 auto;
          background: linear-gradient(to bottom, #0f172a 0%, #1e293b 50%, #0f172a 100%);
          color: white;
          font-family: 'Inter', -apple-system, sans-serif;
          position: relative;
          overflow: hidden;
        }
        
        .print-button {
          position: fixed;
          top: 20px;
          right: 20px;
          background: #dc2626;
          color: white;
          padding: 12px 24px;
          border: none;
          border-radius: 8px;
          cursor: pointer;
          font-weight: 600;
          z-index: 1000;
          box-shadow: 0 4px 12px rgba(220, 38, 38, 0.3);
        }
        
        .print-button:hover {
          background: #b91c1c;
        }
        
        @media print {
          .print-button { display: none; }
        }
      `}</style>
      
      <button className="print-button" onClick={() => window.print()}>
        📄 Flyer drucken
      </button>

      {/* Header Section */}
      <div style={{
        background: 'linear-gradient(135deg, #dc2626 0%, #2563eb 100%)',
        padding: '30mm 15mm',
        textAlign: 'center',
        position: 'relative'
      }}>
        <div style={{
          width: '70px',
          height: '70px',
          background: 'linear-gradient(to bottom right, #dc2626, #2563eb)',
          borderRadius: '16px',
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          marginBottom: '20px',
          border: '3px solid white'
        }}>
          <span style={{ fontSize: '32px', fontWeight: 'bold', color: 'white' }}>FP</span>
        </div>
        
        <h1 style={{
          fontSize: '48px',
          fontWeight: 'bold',
          marginBottom: '10px',
          textShadow: '2px 2px 8px rgba(0,0,0,0.3)'
        }}>
          Funny Point
        </h1>
        
        <div style={{
          display: 'inline-block',
          background: 'rgba(255,255,255,0.2)',
          backdropFilter: 'blur(10px)',
          padding: '12px 30px',
          borderRadius: '50px',
          border: '2px solid rgba(255,255,255,0.3)',
          marginBottom: '15px'
        }}>
          <span style={{ fontSize: '24px', fontWeight: '700' }}>2 Spielhallen unter einem Dach!</span>
        </div>
        
        <p style={{ fontSize: '18px', marginTop: '15px', opacity: 0.95 }}>
          Ihre moderne Spielhalle in Königsbrunn
        </p>
      </div>

      {/* Image Gallery */}
      <div style={{
        display: 'grid',
        gridTemplateColumns: '1fr 1fr 1fr',
        gap: '8px',
        padding: '0 15mm',
        marginTop: '-30px',
        position: 'relative',
        zIndex: 10
      }}>
        {[images.exterior, images.interior1, images.interior2].map((img, idx) => (
          <div key={idx} style={{
            borderRadius: '12px',
            overflow: 'hidden',
            height: '100px',
            boxShadow: '0 8px 24px rgba(0,0,0,0.4)',
            border: '3px solid rgba(255,255,255,0.1)'
          }}>
            <img src={img} alt="Funny Point" style={{
              width: '100%',
              height: '100%',
              objectFit: 'cover'
            }} />
          </div>
        ))}
      </div>

      {/* Main Content */}
      <div style={{ padding: '20mm 15mm 15mm 15mm' }}>
        {/* Features Grid */}
        <div style={{
          display: 'grid',
          gridTemplateColumns: '1fr 1fr',
          gap: '15px',
          marginBottom: '25px'
        }}>
          {[
            { icon: '🎰', title: '16 Geldspielgeräte', desc: 'Merkur & Novoline' },
            { icon: '❄️', title: 'Klimatisierte Räume', desc: 'Immer angenehm' },
            { icon: '🚗', title: 'Großer Parkplatz', desc: 'Kostenlos direkt vor Ort' },
            { icon: '⚡', title: 'Neueste Software', desc: 'Modernste Technik' }
          ].map((feature, idx) => (
            <div key={idx} style={{
              background: 'rgba(255,255,255,0.05)',
              border: '1px solid rgba(255,255,255,0.1)',
              borderRadius: '12px',
              padding: '15px',
              backdropFilter: 'blur(10px)'
            }}>
              <div style={{ fontSize: '28px', marginBottom: '8px' }}>{feature.icon}</div>
              <div style={{ fontSize: '16px', fontWeight: 'bold', marginBottom: '4px' }}>{feature.title}</div>
              <div style={{ fontSize: '13px', opacity: 0.7 }}>{feature.desc}</div>
            </div>
          ))}
        </div>

        {/* Opening Hours */}
        <div style={{
          background: 'linear-gradient(135deg, rgba(220, 38, 38, 0.15) 0%, rgba(37, 99, 235, 0.15) 100%)',
          border: '2px solid rgba(220, 38, 38, 0.3)',
          borderRadius: '16px',
          padding: '20px',
          marginBottom: '20px'
        }}>
          <div style={{ display: 'flex', alignItems: 'center', marginBottom: '15px' }}>
            <div style={{
              width: '40px',
              height: '40px',
              background: 'linear-gradient(to bottom right, #dc2626, #2563eb)',
              borderRadius: '10px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              marginRight: '12px'
            }}>
              <Clock size={24} />
            </div>
            <h2 style={{ fontSize: '24px', fontWeight: 'bold', margin: 0 }}>Öffnungszeiten</h2>
          </div>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px', fontSize: '16px' }}>
            <div>
              <div style={{ fontWeight: '600', marginBottom: '4px' }}>Montag - Samstag</div>
              <div style={{ fontSize: '22px', fontWeight: 'bold', color: '#fbbf24' }}>09:00 - 03:00 Uhr</div>
            </div>
            <div>
              <div style={{ fontWeight: '600', marginBottom: '4px' }}>Sonntag</div>
              <div style={{ fontSize: '22px', fontWeight: 'bold', color: '#fbbf24' }}>11:00 - 03:00 Uhr</div>
            </div>
          </div>
        </div>

        {/* Contact Info */}
        <div style={{
          background: 'rgba(255,255,255,0.05)',
          border: '1px solid rgba(255,255,255,0.1)',
          borderRadius: '16px',
          padding: '20px'
        }}>
          <div style={{ display: 'flex', alignItems: 'center', marginBottom: '15px' }}>
            <MapPin size={24} style={{ marginRight: '8px', color: '#dc2626' }} />
            <h2 style={{ fontSize: '24px', fontWeight: 'bold', margin: 0 }}>So finden Sie uns</h2>
          </div>
          
          <div style={{ display: 'grid', gap: '12px', fontSize: '15px' }}>
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <MapPin size={18} style={{ marginRight: '10px', color: '#fbbf24', flexShrink: 0 }} />
              <div>
                <strong>Hunnenstraße 6, 86343 Königsbrunn</strong><br />
                <span style={{ opacity: 0.7 }}>bei Augsburg, Bayern</span>
              </div>
            </div>
            
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <Phone size={18} style={{ marginRight: '10px', color: '#fbbf24', flexShrink: 0 }} />
              <strong style={{ fontSize: '18px' }}>08231 605939</strong>
            </div>
            
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <Mail size={18} style={{ marginRight: '10px', color: '#fbbf24', flexShrink: 0 }} />
              <span>info@funnypoint.de</span>
            </div>
          </div>
        </div>
      </div>

      {/* Footer */}
      <div style={{
        position: 'absolute',
        bottom: 0,
        left: 0,
        right: 0,
        background: 'rgba(0,0,0,0.3)',
        padding: '15px',
        textAlign: 'center',
        fontSize: '11px',
        borderTop: '1px solid rgba(255,255,255,0.1)'
      }}>
        <div style={{ marginBottom: '8px', fontSize: '13px', fontWeight: '600' }}>
          ✓ Vollständig lizenziert  •  ✓ Gesetzeskonform  •  ✓ Ab 21 Jahren (Bayern)
        </div>
        <div style={{ opacity: 0.6 }}>
          © 2025 Funny Point Spielhalle • Jugendschutzkonform nach bayerischem Recht
        </div>
      </div>
    </div>
  );
};

export default Flyer;